import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("account/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(account_id) {
  const url = get_api_path("account/detail", {}, { account_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(account_id) {
  const url = get_api_path("account/delete", {}, { account_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(account_id, data) {
  const url = get_api_path("account/update", {}, { account_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("account/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function add_student(account_id, data) {
  const url = get_api_path("account/student", {}, { account_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function roles(account_id, data) {
  const url = get_api_path("account/roles", {}, { account_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function stripe(account_id) {
  const url = get_api_path("account/stripe", {}, { account_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del_card(objectmeta_id) {
  const url = get_api_path("account/card/delete", {}, { objectmeta_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};